import { Badge } from "@merge-api/merge-javascript-shared";
import React, { useEffect, useState } from "react";
import { Text } from "@merge-api/merge-javascript-shared";
import { APICategory } from "../../../../../models/Entities";
import { fetchCommonModelsFromCategory } from "../../../../../api-client/categories/CommonModelTogglesAPIClient";
import { fetchComponentSchemasForCategory } from "../../../../../api-client/categories/ComponentSchemasAPIClient";
import {
  createSortedModelsMap,
  SortedModelsMap,
} from "../../../configuration/common-models/CommonModelUtils";
import MergeTable from "../../../../shared/MergeTable";

const SampleSyncHistoryTable = () => {
  const [commonModels, setCommonModels] = useState<SortedModelsMap>({});

  /**
   * Gets the Common Models on page load and sets them in the UI
   */
  useEffect(() => {
    fetchCommonModelsFromCategory(APICategory.ats)
      .then((result) => {
        if (result.status === "success") {
          return createSortedModelsMap(result.data);
        } else {
          return null;
        }
      })
      .then((commonModelsMap) => {
        if (commonModelsMap) {
          fetchComponentSchemasForCategory(APICategory.ats).finally(() => {
            setCommonModels(commonModelsMap);
          });
        }
      });
  }, []);

  return (
    <div className="flex flex-col mb-6">
      <MergeTable
        header={
          <>
            <th scope="col">Model</th>
            <th scope="col">Status</th>
            <th scope="col">Last sync start</th>
          </>
        }
        content={
          <>
            {Object.values(commonModels)
              .filter((model) => model.has_endpoints)
              .map((model) => {
                return (
                  <tr key={model.name}>
                    <td>
                      <b>
                        <Text variant="h6" className="text-gray-40">
                          {model.name}
                        </Text>
                      </b>
                    </td>
                    <td>
                      <Badge>Awaiting connection</Badge>
                    </td>
                    <td>—</td>
                  </tr>
                );
              })}
          </>
        }
      />
    </div>
  );
};

export default SampleSyncHistoryTable;
